/* eslint-disable @typescript-eslint/no-this-alias */
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS202: Simplify dynamic range loops
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import _ from 'underscore';

import { Analytics, tracingCallback } from '@trello/atlassian-analytics';
// eslint-disable-next-line no-restricted-imports
import $ from '@trello/jquery';
import { showFlag } from '@trello/nachos/experimental-flags';

import { Auth } from 'app/scripts/db/Auth';
import { ModelLoader } from 'app/scripts/db/model-loader';
import { ModelCache } from 'app/scripts/db/ModelCache';
import { subscriber } from 'app/scripts/init/subscriber';
import { isOverLimit } from 'app/scripts/lib/limits';
import { l } from 'app/scripts/lib/localize';
import Payloads from 'app/scripts/network/payloads';
import { maybeDisplayLimitsErrorOnCardAdd } from 'app/scripts/views/card/CardLimitsError';
import { View } from 'app/scripts/views/internal/View';
import { LabelLimitsErrorView } from 'app/scripts/views/label/LabelLimitsErrorView';
import { Alerts } from 'app/scripts/views/lib/Alerts';
import { PopOver } from 'app/scripts/views/lib/PopOver';
import { PopoverMoveListTemplate } from 'app/scripts/views/templates/PopoverMoveListTemplate';
import { stopPropagationAndPreventDefault } from 'app/src/stopPropagationAndPreventDefault';

const tooManyCustomFieldsError = 'BOARD_TOO_MANY_CUSTOM_FIELDS';
const tooManyCustomFieldOptionsError = 'CUSTOM_FIELD_TOO_MANY_OPTIONS';

// @ts-expect-error Type '() => string' is not assignable to type '"li"'.ts(2416)
interface ListMoveView {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  _boardData: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  model: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  options: any;
}

class ListMoveView extends View {
  viewTitleKey = 'move list';

  // @ts-expect-error Type '() => string' is not assignable to type '"li"'.ts(2416)
  tagName() {
    return 'form';
  }

  events() {
    return {
      'change .js-select-list-pos': 'renderValues',
      'change .js-select-board': 'updateBoardData',
      'click .js-commit-position': 'commitChange',
      submit: 'commitChange',
    };
  }

  initialize() {
    Analytics.sendScreenEvent({
      name: 'moveListInlineDialog',
      containers: {
        list: {
          id: this.model.id,
        },
        board: {
          id: this.model.getBoard()?.id,
        },
        organization: {
          id: this.model.getBoard()?.getOrganization()?.id,
        },
      },
    });
  }

  render() {
    const view = this;
    const { model } = view;
    const data = {};

    let currentBoard = this.model.getBoard();
    const enterprise = this.model.getBoard().getEnterprise();
    const me = Auth.me();

    // Don't allow guests on enterprise owned boards to move lists off the current board
    const isGuest = currentBoard.isGuest(me);

    // check if the user is an enterprise member of the same enterprise as the board,
    // they can move lists.
    // Also make sure if this is a non enterprise board and a non enterprise user
    // that it won't return a false positive
    const isEnterpriseMember =
      enterprise /* eslint-disable-line eqeqeq */ != null &&
      me.isManagedEntMemberOf(enterprise.get('id'));

    if (isGuest && currentBoard.get('enterpriseOwned') && !isEnterpriseMember) {
      // @ts-expect-error TS(2339): Property 'hasEnterprise' does not exist on type '{... Remove this comment to see the full error message
      data.hasEnterprise = true;
      // @ts-expect-error TS(2339): Property 'enterpriseName' does not exist on type '... Remove this comment to see the full error message
      data.enterpriseName = enterprise?.get('displayName');
      // @ts-expect-error TS(2339): Property 'restrictToCurrentBoard' does not exist o... Remove this comment to see the full error message
      data.restrictToCurrentBoard = true;
      // @ts-expect-error TS(2339): Property 'organizations' does not exist on type '{... Remove this comment to see the full error message
      data.organizations = [
        {
          displayName:
            currentBoard.getOrganization()?.get('displayName') ||
            l('member boards.boards'),
          boards: [{ ...currentBoard.toJSON(), selected: true }],
        },
      ];
    } else if (enterprise /* eslint-disable-line eqeqeq */ != null) {
      // @ts-expect-error TS(2339): Property 'hasEnterprise' does not exist on type '{... Remove this comment to see the full error message
      data.hasEnterprise = true;
      currentBoard =
        this.model
          .getBoard()
          .getMembershipFor(me) /* eslint-disable-line eqeqeq */ == null
          ? currentBoard
          : null;
      // @ts-expect-error TS(2339): Property 'organizations' does not exist on type '{... Remove this comment to see the full error message
      data.organizations = me.getOpenBoardsInEnterpriseByOrg(
        true,
        enterprise.get('id'),
        currentBoard,
      );
      // @ts-expect-error TS(2339): Property 'enterpriseName' does not exist on type '... Remove this comment to see the full error message
      data.enterpriseName = enterprise.get('displayName');
    } else {
      currentBoard = this.model
        .getBoard()
        .isEditableByTeamMemberAndIsNotABoardMember()
        ? currentBoard
        : null;
      // @ts-expect-error TS(2339): Property 'organizations' does not exist on type '{... Remove this comment to see the full error message
      data.organizations = me.getOpenBoardsByOrg(true, currentBoard);
    }

    // @ts-expect-error TS(2339): Property 'organizations' does not exist on type '{... Remove this comment to see the full error message
    for (const org of data.organizations) {
      for (const board of org.boards) {
        if (board.id === model.get('idBoard')) {
          board.selected = true;
        }
      }
    }

    this.$el.html(PopoverMoveListTemplate(data));

    this.updateBoardData();

    return this;
  }

  renderValues() {
    // eslint-disable-next-line @trello/enforce-variable-case
    const $el = $(this.el);

    const idBoard = $el.find('.js-select-board option:selected').val();
    const index = parseInt(
      $el.find('.js-select-list-pos option:selected').text(),
      10,
    );

    // @ts-expect-error
    const board = ModelCache.get('Board', idBoard);
    // @ts-expect-error
    const boardName = board.get('name');

    $el.find('.js-board-value').text(boardName);
    $el.find('.js-pos-value').text(String(index));
  }

  updateBoardData() {
    // eslint-disable-next-line @trello/enforce-variable-case
    const $el = $(this.el);
    // eslint-disable-next-line @trello/enforce-variable-case
    const $selectBoard = $el.find('.js-select-board');
    const idBoardSelected = $selectBoard.find('option:selected').val();

    if (idBoardSelected === this.model.getBoard()?.id) {
      this._boardData = this.model.getBoard();

      for (const list of this._boardData.listList.models) {
        list.cardCount = this._boardData.listList
          ?.get(list.id)
          ?.openCards().length;
      }
      this.updateListList();
    } else {
      // eslint-disable-next-line @trello/enforce-variable-case
      const $otherSelects = $el.find('.select-list,.select-position');
      $otherSelects.attr('disabled', 'disabled');
      // @ts-expect-error TS(2554): Expected 3 arguments, but got 2.
      ModelLoader.loadBoardData(idBoardSelected, Payloads.listsMinimal)
        .then(() => {
          // @ts-expect-error
          this._boardData = ModelCache.get('Board', idBoardSelected);
          this.updateListList();
          return $otherSelects.prop('disabled', false);
        })
        .done();
    }
  }

  updateListList() {
    let count, currentIndex;
    const view = this;
    const { model } = view;

    // eslint-disable-next-line @trello/enforce-variable-case
    const $selectList = $('.js-select-list-pos', this.$el);
    $selectList.empty();

    const openLists = this._boardData.listList.models;
    const isCurrentBoard = this._boardData.id === this.model.getBoard().id;

    if (isCurrentBoard) {
      currentIndex = _.indexOf(openLists, this.model);
      count = openLists.length;
    } else {
      currentIndex = -1;
      count = openLists.length + 1;
    }

    for (
      let i = 0, end = count, asc = 0 <= end;
      asc ? i < end : i > end;
      asc ? i++ : i--
    ) {
      const indexString = String(i + 1);
      const desc =
        i === currentIndex
          ? l('current position', { index: indexString })
          : indexString;

      const pos = this._boardData.listList.calcPos(i, model);
      // eslint-disable-next-line @trello/enforce-variable-case
      const $option = $('<option>').val(pos).text(desc).appendTo($selectList);
      if (i === currentIndex) {
        $option.attr('selected', 'selected');
      }
    }

    // eslint-disable-next-line @trello/enforce-variable-case
    const $commitButton = $('.js-commit-position', this.$el);
    // eslint-disable-next-line @trello/enforce-variable-case
    const $limitExceededError = $('.js-list-limit-exceeded', this.$el);

    if (!isCurrentBoard) {
      const tooManyLists =
        isOverLimit('lists', 'totalPerBoard', this._boardData.get('limits')) ||
        isOverLimit('lists', 'openPerBoard', this._boardData.get('limits'));

      $commitButton
        .toggleClass('disabled', tooManyLists)
        .prop('disabled', tooManyLists);

      if (tooManyLists) {
        Analytics.sendOperationalEvent({
          action: 'errored',
          actionSubject: 'app',
          source: this.options?.source || 'moveListInlineDialog',
          attributes: {
            errorMessage: 'Exceeded lists limit per board',
          },
        });
      }

      $limitExceededError.toggleClass('hide', !tooManyLists);
    } else {
      $commitButton.toggleClass('disabled', false).prop('disabled', false);
      $limitExceededError.toggleClass('hide', true);
    }

    return this.renderValues();
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  commitChange(e: any) {
    stopPropagationAndPreventDefault(e);

    // eslint-disable-next-line @trello/enforce-variable-case
    const $selectListPos = $('.js-select-list-pos', this.$el);
    const listPosSelected = parseInt(
      // @ts-expect-error TS(2345): Argument of type 'string | number | string[] | und... Remove this comment to see the full error message
      $selectListPos.find('option:selected').val(),
      10,
    );
    const idBoardSelected = $(
      '.js-select-board option:selected',
      this.$el,
    ).val();

    this.model.getBoard().composer.save('vis', false);

    const originalBoardId = this.model.getBoard().id;
    const originalPosition = this.model.get('pos');
    const source = this.options?.source || 'moveListInlineDialog';
    if (idBoardSelected === originalBoardId) {
      this.model.update({ pos: listPosSelected });

      Analytics.sendTrackEvent({
        action: 'moved',
        actionSubject: 'list',
        source: 'moveListInlineDialog',
        containers: {
          list: {
            id: this.model.id || '',
          },
          board: {
            id: this.model.getBoard()?.id || '',
          },
          organization: {
            id: this.model.getBoard()?.getOrganization()?.id || '',
          },
        },
      });
    } else if (
      idBoardSelected /* eslint-disable-line eqeqeq */ != null &&
      listPosSelected /* eslint-disable-line eqeqeq */ != null
    ) {
      const traceId = Analytics.startTask({
        taskName: 'edit-list/idBoard',
        source: source,
      });

      if (this.model.cardList.length > 0) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        let hasChecklists: any;
        let hasAttachments = (hasChecklists = false);

        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.model.cardList.forEach((card: any) => {
          hasAttachments = hasAttachments || card.attachmentList.length > 0;
          hasChecklists = hasChecklists || card.checklistList.length > 0;
        });
        // eslint-disable-next-line @trello/enforce-variable-case
        const $elementTarget = e ? $(e.target) : this.$el;

        const options = {
          $elem: $elementTarget,
          hasChecklists,
          hasAttachments,
          destinationBoard: this._boardData,
        };

        if (maybeDisplayLimitsErrorOnCardAdd(options)) {
          Analytics.taskFailed({
            taskName: 'edit-list/idBoard',
            source: source,
            traceId,
            error: new Error('Exceeded a card limit'),
          });
          return;
        }
      }

      const hasLabels = this.model.cardList.filter(
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (c: any) => c.getLabels().length > 0,
      );

      if (
        hasLabels &&
        isOverLimit('labels', 'perBoard', this._boardData.get('limits'))
      ) {
        Analytics.taskFailed({
          taskName: 'edit-list/idBoard',
          source: source,
          traceId,
          error: new Error('Exceeded label limit per board'),
        });
        PopOver.pushView(new LabelLimitsErrorView());
        return;
      }

      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const next = (response: any) => {
        const error = response?.message;
        // eslint-disable-next-line @typescript-eslint/no-shadow
        const source = this.options?.source || 'moveListInlineDialog';

        if (error) {
          this.model.set(
            { idBoard: originalBoardId, pos: originalPosition },
            next,
          );

          Analytics.taskFailed({
            taskName: 'edit-list/idBoard',
            source: source,
            traceId,
            error: error,
          });
        }

        if (error === tooManyCustomFieldsError) {
          Alerts.show('too many custom fields', 'error', 'movelist', 8000);
        } else if (error === tooManyCustomFieldOptionsError) {
          Alerts.show('too many custom options', 'error', 'movelist', 8000);
        } else if (error === 'unauthorized board permission requested') {
          const msg = l('alerts.cannot move list to observer board');
          showFlag({
            id: 'movelist',
            title: msg,
            appearance: 'error',
            isAutoDismiss: true,
            msTimeout: 8000,
          });
        } else if (!error) {
          Analytics.taskSucceeded({
            traceId,
            taskName: 'edit-list/idBoard',
            source: source,
          });

          Analytics.sendTrackEvent({
            action: 'moved',
            actionSubject: 'list',
            source: source,
            attributes: {
              boardSourceId: originalBoardId,
            },
            containers: {
              list: {
                id: this.model.id || '',
              },
              board: {
                // @ts-expect-error TS(2322): Type 'string | number | string[]' is not assignabl... Remove this comment to see the full error message
                id: idBoardSelected || '',
              },
              organization: {
                id: this.model.getBoard()?.getOrganization()?.id || '',
              },
            },
          });
        }
      };
      // When we move a list to a new destination board, server
      // creates a temporary list to hold all the cards while we move the original
      // list to the destination board. There was a bug where the temporary list wasn't
      // deleted properly on the destination board in web, though it was deleted correctly
      // in server. This socket event solves that by listening to changes on the destination
      // board after the list move is complete.
      subscriber.addSubscription({
        // @ts-expect-error TS(2322): Type 'string | number | string[]' is not assignabl... Remove this comment to see the full error message
        idModel: idBoardSelected,
        modelType: 'Board',
        // @ts-expect-error TS(2322): Type '"clientActions"' is not assignable to type '... Remove this comment to see the full error message
        tags: ['clientActions', 'updates'],
      });

      this.model.update(
        {
          idBoard: idBoardSelected,
          pos: listPosSelected,
        },
        tracingCallback({
          taskName: 'edit-list/idBoard',
          source: source,
          traceId,
        }),
        next,
      );
    }

    PopOver.hide();
  }
}

export { ListMoveView };
